import { lazy } from "react"

const {
    REACT_APP_USER_COOKIE,
    REACT_APP_PARTNER_COOKIE
} = process.env

const HomePage = lazy(() => import('../src/pages/HomePage'))
const MarketplacePage = lazy(() => import('../src/pages/MarketplacePage'))
const DetailContentProducts = lazy(() => import('../src/pages/MarketplacePage/DetailMarketplacePage/detailContentProducts'))
const DetailContentServices = lazy(() => import('../src/pages/MarketplacePage/DetailMarketplacePage/detailContentServices'))
const DetailContentJobs = lazy(() => import('../src/pages/MarketplacePage/DetailMarketplacePage/detailContentJobs'))
const DetailContentDonations = lazy(() => import('../src/pages/MarketplacePage/DetailMarketplacePage/detailContentDonations'))
const InformationPage = lazy(() => import('../src/pages/InformationPage'))
const DetailInformationPage = lazy(() => import('../src/pages/InformationPage/DetailInformationPage'))
const TourismPage = lazy(() => import('../src/pages/TourismPage'))
const DetailTourismPage = lazy(() => import('../src/pages/TourismPage/DetailTourismPage'))
const UserAuthPage = lazy(() => import('../src/pages/UserAuthPage'))
const PartnerAuthPage = lazy(() => import('../src/pages/PartnerAuthPage'))
const RegisterPage = lazy(() => import('../src/pages/UserAuthPage/RegisterPage'))
const UserProfilePage = lazy(() => import('../src/pages/ProfilePage/UserProfile'))
const PartnerProfilePage = lazy(() => import('../src/pages/ProfilePage/PartnerProfile'))
const FAQPage = lazy(() => import('../src/pages/FAQPage'))
const ChatPage = lazy(() => import('../src/pages/ChatPage'))
const CreatePage = lazy(() => import('../src/pages/ContentPage/CreatePage'))
const UpdatePage = lazy(() => import('../src/pages/ContentPage/UpdatePage'))
const ComplaintPage = lazy(() => import('../src/pages/Complaint'))
const ForgetPassword = lazy(() => import('../src/pages/UserAuthPage/ForgetPassword'))

/* 
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
            !!!!!!! TARUH SEMUA ROUTES BARU DI 'ELSE' DULU !!!!!!
            !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! 
*/

let ROUTES = []

if (window.sessionStorage.getItem(REACT_APP_USER_COOKIE)) { /* user public allowed routes */
    ROUTES = [
        {
            path: '/',
            element: <HomePage />
        },
        {
            path: '/marketplace',
            element: <MarketplacePage />
        },
        {
            path: '/detail-produk/:id',
            element: <DetailContentProducts />
        },
        {
            path: '/detail-jasa/:id',
            element: <DetailContentServices />
        },
        {
            path: '/detail-pekerjaan/:id',
            element: <DetailContentJobs />
        },
        {
            path: '/detail-donasi/:id',
            element: <DetailContentDonations />
        },
        {
            path: '/informasi',
            element: <InformationPage />
        },
        {
            path: '/detail-informasi/:id',
            element: <DetailInformationPage />
        },
        {
            path: '/pariwisata',
            element: <TourismPage />
        },
        {
            path: '/detail-pariwisata/:id',
            element: <DetailTourismPage />
        },
        {
            path: '/autentikasi-user',
            element: <UserAuthPage />
        },
        {
            path: '/autentikasi-mitra',
            element: <PartnerAuthPage />
        },
        {
            path: '/daftar',
            element: <RegisterPage />
        },
        {
            path: '/user-profile',
            element: <UserProfilePage />
        },
        {
            path: '/partner-profile/:category/:id',
            element: <PartnerProfilePage />
        },
        {
            path: '/chat-list',
            element: <ChatPage />
        },
        {
            path: '/complaint',
            element: <ComplaintPage />
        }
    ]
} else if (window.sessionStorage.getItem(REACT_APP_PARTNER_COOKIE)) { /* partner allowed routes */
    ROUTES = [
        {
            path: '/',
            element: <HomePage />
        },
        {
            path: '/marketplace',
            element: <MarketplacePage />
        },
        {
            path: '/detail-produk/:id',
            element: <DetailContentProducts />
        },
        {
            path: '/detail-jasa/:id',
            element: <DetailContentServices />
        },
        {
            path: '/detail-pekerjaan/:id',
            element: <DetailContentJobs />
        },
        {
            path: '/detail-donasi/:id',
            element: <DetailContentDonations />
        },
        {
            path: '/chat-list',
            element: <ChatPage />
        },
        {
            path: '/partner-profile/:category/:id',
            element: <PartnerProfilePage />
        },
        {
            path: '/informasi',
            element: <InformationPage />
        },
        {
            path: '/detail-informasi/:id',
            element: <DetailInformationPage />
        },
        {
            path: '/pariwisata',
            element: <TourismPage />
        },
        {
            path: '/detail-pariwisata/:id',
            element: <DetailTourismPage />
        },
        {
            path: '/tambah-konten',
            element: <CreatePage />
        },
        {
            path: '/edit-konten/:id',
            element: <UpdatePage />
        }
    ]
} else { /* anonymous allowed routes */
    ROUTES = [
        {
            path: '/',
            element: <HomePage />
        },
        {
            path: '/marketplace',
            element: <MarketplacePage />
        },
        {
            path: '/detail-produk/:id',
            element: <DetailContentProducts />
        },
        {
            path: '/detail-jasa/:id',
            element: <DetailContentServices />
        },
        {
            path: '/detail-pekerjaan/:id',
            element: <DetailContentJobs />
        },
        {
            path: '/detail-donasi/:id',
            element: <DetailContentDonations />
        },
        {
            path: '/informasi',
            element: <InformationPage />
        },
        {
            path: '/detail-informasi/:id',
            element: <DetailInformationPage />
        },
        {
            path: '/pariwisata',
            element: <TourismPage />
        },
        {
            path: '/detail-pariwisata/:id',
            element: <DetailTourismPage />
        },
        {
            path: '/autentikasi-user',
            element: <UserAuthPage />
        },
        {
            path: '/autentikasi-mitra',
            element: <PartnerAuthPage />
        },
        {
            path: '/daftar',
            element: <RegisterPage />
        },
        {
            path: '/user-profile',
            element: <UserProfilePage />
        },
        {
            path: '/partner-profile/:category/:id',
            element: <PartnerProfilePage />
        },
        {
            path: '/faq',
            element: <FAQPage />
        },
        {
            path: '/forget-password',
            element: <ForgetPassword />
        },
    ]
}

export default ROUTES